var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TrustpilotRatingStyles } from './TrustpilotRatingStyles';
import { trustpilotRatingImage } from './utils';
import { TrustPilotFallback } from '../../../atoms/logos/TrustpilotFallback';
import { typographyPx } from '../../../typographyPx';
var ParagraphBody = typographyPx.paragraphBody;
export var TrustpilotRating = function (_a) {
    var stars = _a.stars, trustScore = _a.trustScore, reviews = _a.reviews, _b = _a.theme, theme = _b === void 0 ? 'light' : _b, _c = _a.maxSizeTablet, maxSizeTablet = _c === void 0 ? false : _c;
    return (_jsx(TrustpilotRatingStyles, __assign({ href: "https://uk.trustpilot.com/review/bymiles.co.uk", target: "_blank", rel: "noopener noreferrer", theme: theme, maxSizeTablet: maxSizeTablet }, { children: _jsxs("div", __assign({ className: "trustpilot-rating-wrapper" }, { children: [_jsx(TrustPilotFallback, { logoTheme: theme, clickable: false }), trustpilotRatingImage[stars], _jsxs(ParagraphBody, __assign({ className: "trustpilot-text" }, { children: ["TrustScore ", _jsx("span", __assign({ className: "bold" }, { children: trustScore }))] })), _jsxs(ParagraphBody, __assign({ className: "trustpilot-text" }, { children: [_jsx("span", __assign({ className: "bold" }, { children: reviews.toLocaleString() })), " reviews"] }))] })) })));
};
